export const enLeadPanel = {
	close: "Close lead panel",
	backTo: "Back to {{name}}",
	tabs: { overview: "Overview", research: "Research", timeline: "Timeline", profiles: "Profiles" },
	contextTabs: { leadPanel: "Lead Panel", chat: "Chat" },
	actions: {
		reachOut: {
			default: "Reach out to {{name}}",
			reviewDrafts: "Review drafts ({{count}})",
			reviewDraftsNoCount: "Review drafts",
			reply: "Reply to {{name}}",
			preparing: "Preparing chat…",
		},
		addTo: {
			trigger: "Add to",
			needsListHint: "Add this lead to a list first",
			list: "Add to list",
			addedToList: "Added to list",
			campaign: "Add to campaign",
			addedToCampaign: "Added to campaign",
			tracker: "Add to Profile Tracker",
			addedToTracker: "Added to Profile Tracker",
			crm: "Add to CRM",
			addedToCrm: "Added to CRM",
			createDeal: "Create deal",
			webhook: "Add to webhook",
		},
		campaign: {
			pause: "Pause outreach",
			inbox: "Inbox",
			outbox: "Outbox",
			elsewhere: {
				label: "In an active campaign",
				detail: "{{campaign}} \u00b7 {{list}}",
				link: "View outreach",
			},
			paused: {
				label: "Outreach paused",
				resume: "Resume",
			},
		},
		findMoreLeads: "Find more leads at {{company}}",
		toast: {
			addedToList: "{{name}} added to list",
			addedToTracker: "{{name}} added to Profile Tracker",
			addedToCrm: "{{name}} added to CRM",
			campaignPaused: "Outreach paused for {{name}}",
			campaignResumed: "Outreach resumed for {{name}}",
		},
	},
	placement: {
		title: "Where this lead is",
		otherListsTitle: "Also on these lists",
		inListsTitle: "In lists",
		viewInContacts: "View in contacts",
		kind: {
			INBOX: "In inbox",
			OUTBOX: "In outbox",
			LIST: "On list",
			CONTACTS: "In contacts",
		},
	},
	person: "Person",
	company: "Company",
	scoring: "Lead scoring",
	seniority: "Seniority",
	sentiment: "Sentiment",
	lastContact: "Last contact",
	lastResponse: "Last response",
	companyName: "Company name",
	industry: "Industry",
	location: "Location",
	employees: "Employees",
	foundedYear: "Founded year",
	leadScore: "Lead score",
	personaCategory: "Persona category",
	companyScore: "Company score",
	companyCategory: "Company category",
	leadScoringReasoning: "Lead Scoring Reasoning",
	workHistory: "Work History ({{count}})",
	identity: {
		seeWorkHistory: "See work history",
		connectedOnLinkedin: "Connected on LinkedIn with {{name}}",
		seeMore: "See more",
		hide: "Hide",
		about: "About",
		workHistory: "Work history",
		present: "Present",
		locations: "Locations",
		otherOffices: "Other offices",
		summary: "Summary",
		readMore: "Read more",
		showLess: "Show less",
		employeesRange: "{{from}} \u2013 {{to}} employees",
		employeesCount: "{{formatted}} employees",
		associatedProfiles: "Associated LinkedIn profiles",
	},
	loading: "Loading lead details...",
	loadError: "Lead details could not be loaded.",
	sourceContexts: "Source Contexts ({{count}})",
	sourceContext: "Source Context {{index}}",
	list: "List",
	sourceType: "Source type",
	sourceName: "Source name",
	customColumns: "Custom columns",
	additionalInformation: "Additional information",
	columns: "Columns",
	answerExplanation: "Answer explanation",
	externalLink: "Open source",
	sources: {
		liPost: "LinkedIn post",
		liEvent: "LinkedIn event",
		liCompanyActivity: "LinkedIn company activity",
		offer: "Job offer",
		mapBusiness: "Map business",
	},
	recent: {
		title: "Recent Signals & Activities",
		seeAll: "See all in Timeline →",
		addToTracker: "Add to Profile Tracker",
		empty: {
			title: "No recent signals",
			subtitle:
				"{{name}} and {{company}} aren't on the Profile Tracker yet. Add them to start detecting buying signals.",
		},
		watching: {
			title: "Watching for signals",
			subtitle: "On the Profile Tracker — new signals appear here as they're detected.",
		},
		activity: {
			emailSent: "Email sent to {{name}}",
			linkedinSent: "LinkedIn message sent to {{name}}",
		},
	},
};
